export default __webpack_public_path__ + "static/media/smartKanban.8e98384c.png";